import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";

export default function Layout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  return (
    <div 
      className={`flex min-h-screen bg-background ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`} 
      dir="rtl"
    >
      {/* Desktop Sidebar - Right side in RTL */}
      <div className="hidden md:block h-screen sticky top-0 flex-shrink-0">
        <Sidebar onCollapsedChange={setSidebarCollapsed} />
      </div>
      
      {/* Main Content */}
      <main className="flex-1 overflow-hidden min-w-0 transition-all duration-300">
        <Outlet context={{ sidebarCollapsed }} />
      </main>
      
      {/* Mobile Navigation */}
      <MobileNav />
    </div>
  );
}
